module.exports = ".homeCarousel .owl-carousel .owl-item img {\r\n    height: inherit;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/home-carousel/home-carousel.component.css
// module id = ./src/app/components/ui/home-carousel/home-carousel.component.css
// module chunks = main